import { Box, Drawer, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import FilterContent from "./FilterContent";

export default function CustomDrawer({ filterData, drawerOpen, setDrawerOpen, anchor = "right", content, drawerWidth, title, applyFilter, resetFilter, onCloseNavigate }) {
    const [width, setWidth] = useState(window.innerWidth);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth); // Update state when window resizes
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize); // Cleanup on unmount
        };
    }, [])

    const toggleDrawer = (open) => (event) => {
        
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        
        // Remove 'id' from URL when closing
        if (!open) {
            const searchParams = new URLSearchParams(location.search);
            
            if (searchParams.has('id')) {
                searchParams.delete('id');
                const newSearch = searchParams.toString();
                
                navigate({
                    pathname: location.pathname,
                    search: newSearch ? `?${newSearch}` : '',
                }, { replace: true });
            } 
            
            // Call onCloseNavigate if provided
            if (onCloseNavigate) {
                onCloseNavigate();
            }
        }
        
        setDrawerOpen(open);
    };

    const getdrawerState = (state) => {
        toggleDrawer(state);
    };

    return (
        <div>

            <React.Fragment key={anchor}>
                {/* <Button onClick={toggleDrawer(true)}>{anchor}</Button> */}
                <Drawer
                    anchor={anchor}
                    open={drawerOpen}
                    onClose={toggleDrawer(false)}
                >

                    <Box
                        sx={{
                            borderBottom: '1px solid #E0E0E0',
                            px: 3,
                            py: 3,
                            background: '#fff'
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1.5,
                                fontSize: 18,
                                fontWeight: 600,
                                color: "#282828",
                                pb: 1,
                            }}
                        >
                            <IconButton
                                aria-label="close"
                                onClick={toggleDrawer(false)}
                                sx={{
                                    color: 'grey.500',
                                    mr: 1,
                                    p: 0.5,
                                }}
                            >
                                <i className="ri-close-large-line"></i>
                            </IconButton>
                            <span>{filterData ? <>Filter &amp; Sort</> : title}</span>
                        </Box>
                    </Box>
                    <Box
                        sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : (drawerWidth ? drawerWidth : width > 560 ? 450 : width * 0.93) }}
                        role="presentation"
                    >
                        {filterData ?
                            <Box sx={{minHeight: "100vh",}}>
                                <FilterContent
                                    filterData={filterData}
                                    title={title}
                                    getdrawerState={getdrawerState}
                                    applyFilter={applyFilter}
                                    resetFilter={resetFilter} />
                            </Box>
                            :
                            <Box sx={{ p: 4, pt: 5,  }}>
                                {content}
                            </Box>
                        }
                    </Box>

                </Drawer>
            </React.Fragment>
        </div>
    );
}